import React from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import Row from 'react-bootstrap/Row';
import Container, { ContainerProps } from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

type ColSize = 12 | 6 | 4 | 3 | 2 | 1;

export interface GridProps extends ContainerProps {
  data: any[];
  renderItem: (item: any, index: number) => JSX.Element;
  keyExtractor: (item: any, index: number) => string;
  itemsPerRow: {
    xs?: ColSize;
    sm?: ColSize;
    md?: ColSize;
    lg?: ColSize;
    xl?: ColSize;
  };
  className?: string;
  colClassName?: string;
}

const Grid: React.FC<GridProps> = ({
  data,
  itemsPerRow,
  keyExtractor,
  renderItem,
  className,
  colClassName,
  ...others
}) => {
  const classes = useStyles();
  return (
    <Container className={className} {...others}>
      <Row>
        {data.map((item, index) => (
          <Col
            key={keyExtractor(item, index)}
            xs={itemsPerRow.xs ? 12 / itemsPerRow.xs : undefined}
            sm={itemsPerRow.sm ? 12 / itemsPerRow.sm : undefined}
            md={itemsPerRow.md ? 12 / itemsPerRow.md : undefined}
            lg={itemsPerRow.lg ? 12 / itemsPerRow.lg : undefined}
            xl={itemsPerRow.xl ? 12 / itemsPerRow.xl : undefined}
            className={clsx(classes.col, colClassName)}
          >
            {renderItem(item, index)}
          </Col>
        ))}
      </Row>
    </Container>
  );
};

const useStyles = createUseStyles({
  col: {
    marginBottom: '10px',
  },
});

export default Grid;
